<template>
  <CCol>
    <CRow>
      <CCol>
        <p class="text-muted" v-if="router">
          {{ router.textAccount }}
          <CLink class="mx-2 text-primary" :to="{ name: router.name }">
            {{ router.text }}
          </CLink>
        </p>
      </CCol>
    </CRow>
    <CRow class="socialLogin d-flex justify-content-between">
      <CCol sm="12" md="6" class="m-sm-2 m-md-0 my-md-0 d-flex align-items-center" v-for="(item, i) in payload" :key="item.name">
        <CButton
          shape="pill"
          color="white"
          v-c-emit-root-event:sign-social="item.name"
          class="socialLogin__button btn-white text-gray-700 py-sm-3 btn-block d-flex align-content-center justify-content-center"
          @click="item.action"
        >
          <i class="cib-google c-icon c-icon-custom-size m-0 mr-sm-2 d-flex" :class="`cib-${item.name}`"></i>
          <span>{{ router.textButton }} {{ item.name }}</span>
        </CButton>
        <div class="text-muted ml-4 d-flex" v-if="!i == payload.length - 1">Or</div>
      </CCol>
    </CRow>
    <CRow>
      <CCol>
        <p class="text-muted text-lowercase mb-4 mt-4">
          {{ $t('auth.sociallogin.text.sign-email', { sign: $t('auth.sociallogin.link.signin') }) }}
        </p>
      </CCol>
    </CRow>
  </CCol>
</template>

<script>
export default {
  name: 'SocialLogin',
  props: {
    // payload: {
    //   type: Array,
    //   default: () => {
    //     return [
    // { name: "Google", action: this.click_google },
    // { name:"linkedin", action: this.click_linkedin }
    //     ]
    //   }
    // },
  },
  data() {
    return {
      payload: [
        { name: 'Google', action: this.click_google },
        { name: 'linkedin', action: this.click_linkedin },
      ],
      google: {
        url: this.$configs.VUE_APP_GOOGLE_URL,
        client_id: this.$configs.VUE_APP_GOOGLE_CLIENT_ID,
        url_redirect: this.$configs.VUE_APP_GOOGLE_URL_REDIRECT,
        scope: this.$configs.VUE_APP_GOOGLE_SCOPE,
      },
      linkedin: {
        url: this.$configs.VUE_APP_LINKEDIN_URL,
        client_id: this.$configs.VUE_APP_LINKEDIN_CLIENT_ID,
        url_redirect: this.$configs.VUE_APP_LINKEDIN_URL_REDIRECT,
        scope: this.$configs.VUE_APP_LINKEDIN_SCOPE,
      },
    }
  },
  methods: {
    buildGoogleUrl() {
      let urlResult = `${this.google.url}?scope=${encodeURI(
        this.google.scope,
      )}&include_granted_scopes=true&response_type=token&state=state_parameter_passthrough_value&redirect_uri=${encodeURI(
        this.google.url_redirect,
      )}&client_id=${this.google.client_id}`
      return urlResult
    },
    buildLinkedinUrl() {
      let urlResult = `${this.linkedin.url}?response_type=code&client_id=${this.linkedin.client_id}&redirect_uri=${encodeURI(
        this.linkedin.url_redirect,
      )}&state=fooobar&scope=${encodeURI(this.linkedin.scope)}`
      return urlResult
    },
    click_google() {
      window.location = this.buildGoogleUrl()
    },
    click_linkedin() {
      window.location = this.buildLinkedinUrl()
    },
  },
  computed: {
    router() {
      if (this.$route.name === 'NewRegister') {
        return {
          name: 'Login',
          textAccount: this.$t('auth.auth.sociallogin.text.alread-account'),
          textButton: this.$t('auth.sociallogin.link.signup'),
          text: this.$t('auth.sociallogin.link.signin'),
        }
      } else {
        // MVP2-1772
        // return {
        //   name : 'NewRegister',
        //   textButton: this.$t("auth.sociallogin.link.signin"),
        //   textAccount: this.$t("auth.sociallogin.text.dont-account"),
        //   text : this.$t("auth.sociallogin.link.signup")
        // }
        return false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.socialLogin {
  &__button {
    height: 60px;
    font-size: 1.1em;
    border: 0px;
    box-shadow: 0px 10px 21px 0 rgba(34, 37, 43, 0.03) !important;
    transition: all 300ms;
    &:hover {
      background: var(--white);
      box-shadow: 0px 10px 21px 0 rgba(34, 37, 43, 0.08) !important;
    }

    .c-icon {
      height: 1.1em;
      width: 1.1em;
      font-size: 1.6em;
    }
  }
}
</style>
